import HSDict, { HSEntry } from '@/utils/constants/hs-codes'

// Harmonic Systems code parsers / generators
// These include HTS & TARIC extensions
// for HTS & TARIC, region-specific + CN/meta extensions is separated,
// for HTS the meta digits (last two digits) are separated into the cn field as well since the distincion can only be made based on the origin country

// HS = Harmonic Systems
// HTS = Harmonized Tariff Schedule
// TARIC = integrated Tariff of the European Union

type HSCode = string // TODO conditional based on the length & composition of _code

type HSCodeDefinition = {
  chapter: string,
  heading: string,
  subheading: string,
  extension: string,
  cn: string
}


// NOTE products can be automatically categorized based on their HS-code
export default class HarmonicSystemsCode {
  private _raw: string | number

  private _chapter: string
  private _heading: string
  private _subheading: string
  private _extension: string
  private _cn: string

  constructor (code: HSCodeDefinition) {
    this._chapter = code.chapter
    this._heading = code.heading
    this._subheading = code.subheading
    this._extension = code.extension
    this._cn = code.cn
    this.fromDefinition(code)
    this._raw = this.value
  }

  get raw () {
    return this._raw
  }

  get value (): HSCode {
    //if (!this.chapter) return undefined
    return `${this.chapter}${this.heading}${this.subheading}${this.extension}${this.cn}`
  }

  set value (code: string | undefined) {
    if (code === undefined) return
    console.log(code)
    this._raw = code
    this.parse(code)
  }

  get valid (): boolean {
    return (!!this._chapter && !!this._heading && !!this._subheading &&
      (this.find({
        chapter: this._chapter,
        heading: this._heading,
        subheading: this._subheading,
        extension: this._extension,
        cn: this._cn
      }).length > 0))
  }

  get data (): HSCodeDefinition & { valid?: boolean, value?: HSCode } {
    return {
      chapter: this._chapter,
      heading: this._heading,
      subheading: this._subheading,
      extension: this._extension,
      cn: this._cn,
      valid: this.valid,
      value: this.value // value of combined parts
    }
  }


  get chapter () { return this._chapter || '' }
  get heading () { return this._heading || '' }
  get subheading () { return this._subheading || '' }
  get extension () { return this._extension || '' }
  get cn () { return this._cn || '' }

  fromDefinition (definition: HSCodeDefinition) {
    this._chapter = definition.chapter
    this._heading = definition.heading
    this._subheading = definition.subheading
    this._extension = definition.extension
    this._cn = definition.cn

    return this.data
  }

  parse (code: string | number): HSCodeDefinition {
    const c = String(code)
    // 1-2
    this._chapter = c[0] + c[1]

    // 3-4
    this._heading = c[2] + c[3]

    // 5-6
    this._subheading = c[4] + c[5]

    // 7-8 (HTS / NCM)
    this._extension = c[6] + c[7]

    // 9 - 10 (TARIC / data collection meta (if '00'?))
    this._cn = c[8] + c[9]

    return this.data
  }

  find (data = this.data): Array<HSEntry> {
    return [
      HSDict.byCode[data.chapter],
      HSDict.byCode[data.chapter+data.heading],
      HSDict.byCode[data.chapter+data.heading+data.subheading],
      HSDict.byCode[data.chapter+data.heading+data.subheading+data.extension],
      HSDict.byCode[data.chapter+data.heading+data.subheading+data.extension+data.cn]
    ].filter(Boolean)
  }

  // static parse (code: string | number): HSCodeDefinition {
  //   return new HarmonicSystemsCode(code).data
  // }

  // static find (code: string | number): Array<HSEntry> {
  //   const data = new HarmonicSystemsCode(code).data
  //   return [
  //     HSDict.byCode[data.chapter],
  //     HSDict.byCode[data.chapter+data.heading],
  //     HSDict.byCode[data.chapter+data.heading+data.subheading],
  //     HSDict.byCode[data.chapter+data.heading+data.subheading+data.extension],
  //     HSDict.byCode[data.chapter+data.heading+data.subheading+data.extension+data.cn]
  //   ].filter(Boolean)
  // }
}